<div class="popup-event">
    <button class="popup-close" tabindex="0" (click)="closeDialog()">
        <svg width="22" height="22" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.5994 1.39941L1.39941 20.5994M1.39941 1.39941L20.5994 20.5994" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round"></path>
        </svg>
    </button>
    <div class="popup-body">
        <div class="popup-form" *ngIf="!loading">
            <div class="thanks-block" *ngIf="sentSucceeded">
                <div class="thanks-block-img">
                    <img [src]="eventForm.succeedImageMessage" width="110" height="110" />
                </div>
                <h2 class="thanks-block_title">{{resultSendText}}</h2>
                <p class="thanks-block_sub-title">{{resultSendSubText}}</p>
            </div>

            <form *ngIf="!sentSucceeded" [formGroup]="form" novalidate class="main-from" (submit)="onSubmit()">
                <h3 class="main-from_title">{{eventForm.topTitle}}</h3>
                <p class="main-from_sub-title">{{eventForm.requiredFieldsText}}</p>

                <mat-form-field *ngIf="eventForm.fullNameFieldEnabled" appearance="outline" class="control-field">
                    <mat-label>{{eventForm.fullNameLabel}}</mat-label>
                    <input matInput formControlName="username">
                    <mat-error *ngIf="form.controls['username'].hasError('required')">
                        {{eventForm.fullNameBlankErrorMessage}}
                    </mat-error>
                </mat-form-field>

                <mat-form-field *ngIf="eventForm.emailFieldEnabled" appearance="outline" class="control-field">
                    <mat-label>{{eventForm.emailLabel}}</mat-label>
                    <input matInput formControlName="email">
                    <mat-error *ngIf="form.controls['email'].hasError('required')">
                        {{eventForm.emailBlankErrorMessage}}
                    </mat-error>
                    <mat-error *ngIf="form.controls['email'].hasError('email')">
                        {{eventForm.emailInvalidErrorMessage}}
                    </mat-error>
                </mat-form-field>

                <mat-form-field *ngIf="eventForm.phoneFieldEnabled" appearance="outline" class="control-field">
                    <mat-label>{{eventForm.phoneLabel}}</mat-label>
                    <input matInput formControlName="phone">
                    <mat-error *ngIf="form.controls['phone'].hasError('required')">
                        {{eventForm.phoneBlankErrorMessage}}
                    </mat-error>
                    <mat-error *ngIf="form.controls['phone'].hasError('invalidMobilePhoneValidator')">
                        {{eventForm.phoneInvalidErrorMessage}}
                    </mat-error>
                </mat-form-field>

                <mat-form-field *ngIf="eventForm.multiSelectOptionFieldEnabled && eventForm.multiSelectOptionsWithEmail && eventForm.multiSelectOptionsWithEmail.length" 
                        appearance="outline" class="control-field">
                    <mat-label>{{eventForm.multiSelectOptionsLabel}}</mat-label>
                    <mat-select formControlName="events">
                        <mat-option *ngFor="let item of eventForm.multiSelectOptionsWithEmail" 
                            [value]="item"
                            >{{item.value}}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="form.controls['events'].hasError('required')">
                        {{eventForm.multiSelectOptionsFieldBlankErrorMessage}}
                    </mat-error>
                </mat-form-field>

                <div *ngIf="eventForm.singleSelectOptionFieldEnabled && eventForm.singleSelectOptionsWithEmail && eventForm.singleSelectOptionsWithEmail.length" 
                        class="customer-service-checkboxes">
                    <label class="customer-service-checkboxes_label">{{eventForm.singleSelectOptionsLabel}}</label>
                    <mat-radio-group formControlName="radioSelect" class="radio-group">
                        <mat-radio-button *ngFor="let option of eventForm.singleSelectOptionsWithEmail" [value]="option">{{option.value}}</mat-radio-button>
                    </mat-radio-group>
                    <mat-error *ngIf="form.controls['radioSelect'].hasError('required') && form.controls['radioSelect'].touched">
                        {{eventForm.singleSelectOptionsFieldBlankErrorMessage}}
                    </mat-error>
                </div>

                <div *ngIf="eventForm.deliveryConfirmationTextEnabled" class="customer-service-uniq-check">
                    <mat-slide-toggle formControlName="toggleButton" class="toggle-checkbox">{{eventForm.deliveryConfirmationText}}</mat-slide-toggle>
                </div>

                <div class="customer-service-confirm">
                    <mat-checkbox formControlName="deliveryInformation">
                        {{eventForm.deliveryInformationConfirmationText}}
                    </mat-checkbox>
                </div>

                <div class="customer-service-submit">
                    <button mat-flat-button color="primary" class="w-100" [disabled]="loading">{{eventForm.sendButtonText}}</button>
                </div>  
            </form>
        </div>
        <div class="popup-form preloader-view" *ngIf="loading">
            <div class="preloader--mini">
                <div class="preloader__icon">
                    <img alt="" height="50" loading="lazy" src="Content/Images/icons/preloader.png?format=webp" width="50">
                </div>
            </div>
        </div>

        <div class="popup-back">
            <img src="/Content/Images/triangles/popup.png" width="794" height="158" />
        </div>
        <div class="popup-img">
            <img [src]="eventForm.backgroundImageUrl" width="300" height="600" />
        </div>
    </div>
</div>